const Resume = () => {
  return (
    <section id="resume" className="resume">
      <div className="resume__wrapper">
        <h2 data-aos="fade-up">Resume</h2>
        <main className="resume__container" data-aos="fade-up">
          <a
            className="btn"
            href="./img/Miguel de leon.pdf"
            target="_blank"
            rel="noreferrer"
          >
            View my Resume
          </a>
        </main>
      </div>
    </section>
  );
};

export default Resume;
